<template>
    <div class="main container">
        <hint></hint>
        <left></left>
        <div class="right abs">
            <section>
                <div class="upper cb ofh">
                    <!-- <div @click="showSelected">selected</div> -->
                    <div class="fl cp btn-add" alt @click="addFile()"></div>
                    <div class="fl cp btn-addFolder" alt @click="addFolder()"></div>
                    <div class="fr cp btn-remove" alt @click="removeAll()"></div>
                </div>
                <div class="lower white2 cb ofh">
                    <p class="wh240">
                        <el-checkbox @change="selectAll" v-model="checkAll"></el-checkbox>
                        <span class="fileName">文件名称</span>
                    </p>
                    <p class="wh108">文件大小</p>
                    <p class="wh108">压缩后大小</p>
                    <p class="wh108">压缩率</p>
                    <p class="wh108">压缩状态</p>
                    <p class="wh179">进度</p>
                    <p class="wh179">操作</p>
                </div>
            </section>
            <!-- 两个页面不一样 -->
            <div class="before" v-show="!files.length">
                <div class="default_img abs cp ct" @click="addFile()">
                    <img src="img/gen/pic_default.png" alt>
                    <br>
                    <p class="hint1">暂无文件</p>
                    <div class="hint non">
                        <img src="img/gen/ico_tishi.png" alt>
                        非VIP用户可转换最大2M的文件，升级VIP用户无大小限制。
                    </div>
                </div>
            </div>
            <!-- 只要空就看不见 -->
            <vue-scroll :ops="ops" v-show="files.length">
                <section class="fileList" v-show="files.length">
                    <ul>
                        <li class="cb ofh" v-for="(file,index) in files" :key="index">
                            <p class="wh240 ellipsis">
                                <el-checkbox @change="selectFile(file)" v-model="file.checked"></el-checkbox>
                                <span class="fileName">{{file.name}}</span>
                            </p>
                            <p class="wh108">{{formatSize(file.size,2)}}</p>
                            <p
                                class="wh108"
                            >{{file.compressedSize ? formatSize(file.compressedSize,2) : ""}}</p>
                            <p class="wh108">{{file.compresseRatio ? file.compresseRatio +'%' : ""}}</p>
                            <p
                                class="wh108"
                                :class="{failColor : file.status == 2}"
                            >{{getStatusText(file.status)}}</p>
                            <p class="wh179">
                                <span v-if="file.status != 2">
                                    <progress-bar :percent="file.process"></progress-bar>
                                    {{file.process}}%
                                </span>
                                <span v-else>
                                    <span @click="retry(file)">
                                        <img
                                            class="retry_icon cp"
                                            src="img/gen/ico_chongxinzhuanghuan.png"
                                        >
                                    </span>
                                </span>
                            </p>
                            <div class="wh179 fc">
                                <div
                                    class="cp btn-item btn-item-openDir"
                                    alt
                                    @click="itemOpenDir(file)"
                                ></div>
                                <div class="cp btn-item btn-item-open" alt @click="itemOpen(file)"></div>
                                <div
                                    class="cp btn-item btn-item-remove"
                                    alt
                                    @click="removeFile(index)"
                                ></div>
                            </div>
                        </li>
                    </ul>
                </section>
            </vue-scroll>
        </div>
        <popup-tip ref="tip"></popup-tip>
        <keep-alive>
            <bottom
                v-show="files.length"
                action="compress"
                :emptyFiles="emptyFiles"
                @imageCompress="imageCompress"
                @receiveCompType="receiveCompType"
                @receiveOutpath="receiveOutpath"
            ></bottom>
        </keep-alive>
    </div>
</template>
<script>
import PopupTip from "../components/common/PopupTip";
import Hint from "../components/common/Hint";
import Left from "../components/common/Left";
import Bottom from "../components/common/Bottom";
import ProgressBar from "../components/common/ProgressBar";
import { formatSize } from "../../src/assets/js/utils";
import File from "../mixin/File.js";
import bus from "../mixin/eventBus.js";
import Drop from "../mixin/tui-dropper.js";

export default {
    name: "Compress",
    components: { Left, Bottom, ProgressBar, PopupTip, Hint },
    mixins: [File, Drop],
    mounted() {
        var _this = this;
        var dropArea = window.$('.before')[0];
        _this.AttchDropMulti(dropArea, function (files) {
            for (let i = 0; i < files.length; i++) {
                let file = files[i]; //页面初始，不需要判断重复
                let type = file.name.split(".").pop().toLowerCase() || "";
                if (_this.allowExt.indexOf(type) > -1) {
                    let obj = {
                        name: file.name,
                        path: file.path,
                        type: '',
                        size: file.size, //单位字节
                        compressedSize: "", //压缩后大小
                        compresseRatio: "", //压缩率
                        status: 0,
                        process: 0, //进度
                        outPath: "", //输出路径
                        checked: true //是否选中
                    };
                    _this.files.push(obj); //加入转换列表
                } else {
                    if (1 === files.length) {
                        _this.$refs.tip.show({ content: '不支持的格式' });
                    }
                }
            }
        });
    },
    data: function () {
        return {
            ops: {
                bar: {
                    background: 'rgba(210, 210, 210, 1)',
                },
            },
            isVip: true,
            inHeic: false,
            outPath: "",
            files: [], //转换列表
            selectedFiles: [], //用户勾选的文件
            quality: "",
            checkAll: false,
            allowExt: ["jpg", "jpeg", "gif", "png", "heic"], //允许上传的后缀
            emptyFiles: true,
            alerted: false,
        };
    },
    methods: {
        showSelected: function () {
            console.log({ ...this.selectedFiles });
        },
        //全选
        selectAll: function () {
            //this.files.forEach(file => {
                //file.checked = this.checkAll;
                // if(file.checked){
                //     this.selectedFiles.push(file);
                // }else{
                //     this.selectedFiles.splice(index);
                // }
            //});

        },
        //选择单个文件
        selectFile: function () {
            // if (file.checked) {
            //     this.selectedFiles.push(file);
            // } else {
            //     let index = this.selectedFiles.findIndex(ele => ele.path === file.path);
            //     this.selectedFiles.splice(index, 1);
            // }
        },
        receiveCompType: function (comType) {
            switch (comType) {
                case "normal":
                    this.quality = 2;
                    break;
                case "small":
                    this.quality = 1;
                    break;
                case "clear":
                    this.quality = 3;
                    break;
                default:
                    break;
            }
        },
        //获取outpath
        receiveOutpath: function (outPath) {
            this.outPath = outPath;
        },
        /**
         * 格式转换
         */
        imageCompress: function () {
            this.alerted = false;
            this.compress(this.files);
            //如果勾选文件则转换勾选文件
            // if (this.selectedFiles.length > 0) {
            //     this.compress(this.selectedFiles);
            // } else {
            //     this.compress(this.files);
            // }
        },
        //添加文件
        addFile: function () {
            let _that = this;
            this._btnClickFun(false, this.allowExt, function (files) {
                for (let i = 0; i < files.length; i++) {
                    let file = files[i];
                    if (!_that._inArray(file, _that.files, "path")) {
                        let type = file.name.split(".").pop().toLowerCase() || "";
                        if (_that.allowExt.indexOf(type) > -1) {
                            let obj = {
                                name: file.name,
                                path: file.path,
                                type: "",
                                size: file.size, //单位字节
                                compressedSize: "", //压缩后大小
                                compresseRatio: "", //压缩率
                                status: 0,
                                process: 0, //进度
                                outPath: "", //输出路径
                                checked: true //是否选中
                            };
                            //加入转换列表
                            _that.files.push(obj);
                        } else {
                            if (1 === files.length) {
                                _that.$refs.tip.show({ content: '不支持的格式' });
                            }
                        }

                    }
                }
            });
        },
        //重新压缩
        retry: function (file) {
            let files = [];
            files.push(file);
            this.compress(files);
        },
        //压缩
        compress: function (files) {
            let _that = this;
            files.forEach(file => {
                if (!file.checked) return;
                file.process = 80;
                _that.setStatus(file, 0);
                let outPath = this.outPath + "\\" + file.name;
                window.magickImg.compress(file.path, outPath, this.quality,
                    function () {
                        //成功
                        file.process = 100;
                        file.outPath = outPath;
                        _that.setStatus(file, 1);
                        //计算压缩率
                        [file.compressedSize, file.compresseRatio] = _that.computeComopressRatio(file);
                    },
                    function () {
                        _that.setStatus(file, 2);
                        if(!_that.alerted){
                            window.toastr.error('有文件转换失败了，貌似奴家也无能为力...');
                            _that.alerted = true;
                        }
                        // window.console.error(e);
                    }
                );
            });
        },
        setStatus(file, status) {
            return file.status = status;
        },
        getStatusText(status) {
            let txt;
            switch (status) {
                case 0:
                    txt = "待转换";
                    break;
                case 1:
                    txt = "转换成功";
                    break;
                case 2:
                    txt = "转换失败";
                    break;
                default:
                    txt = "待转换";
                    break;
            }
            return txt;
        },
        //计算压缩率
        computeComopressRatio(file) {
            //获取压缩后文件的大小
            let stat = this.getFileInfo(file.outPath);
            let ratio = ((stat.size / file.size) * 100).toFixed(2);
            return [stat.size, ratio > 100 ? 100 : ratio];
        },
        formatSize(size) {
            return formatSize(size);
        },
        /**
         * 添加文件夹
         */
        addFolder: function () {
            let _this = this;
            _this._btnClickFun(true, this.allowExt, function (folder) {
                let path = folder.path;
                window.fs.readdir(path, function (err, files) {
                    if (err) {
                        //读取是否出错
                        window.console.error(err);
                    } else {
                        let types = ["jpg", "jpeg", "gif", "png", "heic"];
                        for (let i = 0; i < files.length; i++) {
                            let file = files[i];
                            let type = file.split('.').pop().toLowerCase() || '';
                            if (types.indexOf(type) > -1) {
                                let stat = window.fs.statSync(path + '\\' + file);
                                let obj = {
                                    name: file,
                                    path: path + '\\' + file,
                                    type: "",
                                    size: stat.size, //单位字节
                                    compressedSize: "", //压缩后大小
                                    compresseRatio: "", //压缩率
                                    status: 0,
                                    process: 0, //进度
                                    outPath: "", //输出路径
                                    checked: true //是否选中
                                };
                                //加入转换列表
                                _this.files.push(obj);
                            }
                        }
                    }
                });
            });
        },
        /**
         * 清除
         */
        removeAll: function () {
            if (!this.files.length) return;
            this.$refs.tip.show({content:'确定要清空列表吗？', confirmAction: 'removeAll' });
            let _that = this;
            bus.$off('removeAll').$on('removeAll', () => {
                _that.files = [];
                _that.checkAll = false;
                //_that.$storage.remove("compress_files");
            });
        },
        //打开文件所在文件夹
        itemOpenDir(v) {
            window.shell.showItemInFolder(v.path)
            //window.openDir(v.path.substr(0, v.path.indexOf(v.name)));
        },
        itemOpen(v) {
            window.openDir(v.path);
        },
        /**
         * 删除单个图片
         * */
        removeFile(k) {
            this.$refs.tip.show({content:'确定要删除文件吗？', confirmAction: 'removeFile' });
            let _that = this;
            bus.$off('removeFile').$on('removeFile', () => {
                _that.files.splice(k, 1);
            });
            //_this.$storage.set('transform_files', _this.files);
        },
        /**
         * 验证数据是否在数组中存在(按属性验证)
         * @param data 验证数据
         * @param arr 被验证的数组
         * @param name 验证的属性
         * @returns {boolean}
         * @private
         */
        _inArray: function (data, arr, name) {
            for (let v of arr) {
                if (data[name] == v[name]) {
                    return true;
                }
            }
            return false;
        }
    },
    watch: {
        files: {
          handler: function () {
            if(!this.files.length){
                this.checkAll = false;
                return;
            }
            let i = 0;
            this.files.forEach(file => {
                if(file.checked){
                    i++;
                }
            });
            if(i == this.files.length){
                this.checkAll = true;
                this.emptyFiles = false;
            }else if(i == 0){
                this.checkAll = false;
                this.emptyFiles = true;
            }else{
                this.emptyFiles = false;
            }
            //仅仅只是做个标记，Left 组件要判断
            window.editorUrls = this.files;
          },
          deep: true,//深度监听
          immediate: true
        },
        checkAll(value){
            let i = 0;
            this.files.forEach(file => {
                file.checked = value;
                if(file.checked){
                    i++;
                }
            });
            if(i){
                this.emptyFiles = false;
            } else{
                this.emptyFiles = true;
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.before {
    height: 480px;
}
.right {
    left: 115px;
    right: 1px;
}
.wh240 {
    width: 240px;
}
.wh108 {
    width: 108px;
}
.wh179 {
    width: 179px;
}
.lower {
    display: flex;
}
.upper,
.lower {
    border-bottom: 1px solid #e2e5ec;
}
.upper {
    height: 57px;
    padding-left: 15px;
}
.upper img:nth-of-type(1) {
    margin-left: 18px;
}
.upper img {
    margin-top: 11px;
}
.upper .first {
    margin-left: 17px;
}
.upper .last {
    margin-left: 5px;
}
.upper .fr {
    margin-right: 20px;
}
.lower {
    height: 41px;
    line-height: 40px;
}
.lower .white3 {
    width: 16px;
    height: 16px;
    margin-top: 12px;
    /* margin-left: 20px; */
}
.lower p {
    padding-left: 10px;
    font-size: 12px;
    color: #464851;
    border-left: 1px solid #e2e5ec;
    box-sizing: border-box;
}
.lower p:nth-of-type(1) {
    border-left: none !important;
}
.fileName {
    margin-left: 10px;
}
.lower p.fl {
    padding-left: 7px;
    border-left: none;
}
.lower .last,
.lower .fourth {
    width: 169px;
}
.lower .third,
.lower .first {
    width: 131px;
}
.lower .second {
    width: 144px;
}
.fileList {
    max-width: 1036px;
    max-height: 400px;
    /* padding-top: 5px;      */
}
.fileList li {
    display: flex;
    padding-left: 10px;
}
.fileList li:nth-of-type(even) {
    background-color: #fdfdfd;
}
.last,
.fourth {
    width: 179px;
}
.third {
    width: 132px;
    padding-left: 10px;
}
.second {
    width: 144px;
}
.first {
    width: 142px;
    padding-left: 10px;
}
.last img {
    margin: 3px 5px 0px 7px;
}
.fourth .gray2 {
    width: 63%;
    height: 4px;
    margin-top: 20px;
    margin-right: 8px;
}
.fourth img {
    margin-left: 60px;
    margin-top: 2px;
}
li {
    height: 40px;
}
li .white3 {
    width: 16px;
    height: 16px;
    margin-top: 12px;
    /* margin-left: 20px; */
}
p {
    line-height: 40px;
    font-size: 12px;
    color: #464851;
}
p.fl {
    padding-left: 7px;
}
.brl {
    border-radius: 4px 0px 0px 4px;
}
.brr {
    width: 16px;
    height: 23px;
    margin-top: 9px;
    border-radius: 0px 4px 4px 0px;
    border-right: 1px solid #e2e5ec;
    border-top: 1px solid #e2e5ec;
    border-bottom: 1px solid #e2e5ec;
}
.brr img {
    padding-top: 8px;
    padding-bottom: 2px;
    padding-left: 5px;
}
.failColor {
    color: #ff2020;
}
.default_img {
    width: 400px;
    top: 230px;
    left: 0px;
    right: 0px;
    margin: auto;
    padding-top: 50px;
    padding-bottom: 50px;
}
.default_img .hint1 {
    margin-top: 10px;
    font-size: 18px;
    color: #464851;
}
.default_img .hint {
    /* 非 vip 用户 */
    font-size: 12px;
    color: #949494;
}
.el-checkbox {
    margin-left: 10px;
    margin-right: 0px;
}
.fc {
    display: flex;
    align-items: center;
}
.retry_icon {
    margin-left: 50px;
    margin-top: 3px;
}
.btn-add {
    width: 110px;
    height: 36px;
    margin-top: 10px;
    background: url("../../public/img/trans/btn_tianjiaupian01.png") no-repeat;
}
.btn-add:hover {
    background: url("../../public/img/trans/btn_tianjiaupian02.png") no-repeat;
}
.btn-add:active {
    background: url("../../public/img/trans/btn_tianjiaupian03.png") no-repeat;
}
.btn-addFolder {
    width: 110px;
    height: 36px;
    margin-top: 10px;
    background: url("../../public/img/trans/btn_tinajiawenjianjia01.png")
        no-repeat;
}
.btn-addFolder:hover {
    background: url("../../public/img/trans/btn_tinajiawenjianjia02.png")
        no-repeat;
}
.btn-addFolder:active {
    background: url("../../public/img/trans/btn_tinajiawenjianjia03.png")
        no-repeat;
}
.btn-remove {
    width: 110px;
    height: 36px;
    margin-top: 10px;
    background: url("../../public/img/trans/btn_qingkongliebiao01.png")
        no-repeat;
}
.btn-remove:hover {
    background: url("../../public/img/trans/btn_qingkongliebiao02.png")
        no-repeat;
}
.btn-remove:active {
    background: url("../../public/img/trans/btn_qingkongliebiao03.png")
        no-repeat;
}
.btn-item {
    width: 34px;
    height: 34px;
    margin-right: 15px;
}
.btn-item-openDir {
    background: url("../../public/img/trans/btn_dakai01.png") no-repeat;
}
.btn-item-openDir:hover {
    background: url("../../public/img/trans/btn_dakai02.png") no-repeat;
}
.btn-item-openDir:active {
    background: url("../../public/img/trans/btn_dakai03.png") no-repeat;
}
.btn-item-open {
    background: url("../../public/img/trans/btn_sousuo01.png") no-repeat;
}
.btn-item-open:hover {
    background: url("../../public/img/trans/btn_sousuo02.png") no-repeat;
}
.btn-item-open:active {
    background: url("../../public/img/trans/btn_sousuo03.png") no-repeat;
}
.btn-item-remove {
    background: url("../../public/img/trans/btn_shanchu01.png") no-repeat;
}
.btn-item-remove:hover {
    background: url("../../public/img/trans/btn_shanchu02.png") no-repeat;
}
.btn-item-remove:active {
    background: url("../../public/img/trans/btn_shanchu03.png") no-repeat;
}
</style>
